module.exports = __webpack_public_path__ + "img/visa-logo.9796483.png";